// extracted by mini-css-extract-plugin
module.exports = {"styledDropdownMenu":"N45C5MWN"};